import React from 'react';
import ModuleBadge from './ModuleBadge';
import PremiumBadge from './PremiumBadge';
import Spinner from './Spinner';
import ActionBtn from './ActionBtn';

export default function QueryTableRow({ query, onView, onDelete, deleting }) {
  return (
    <tr
      style={{ borderBottom: '1px solid #1a1c26', transition: 'background-color 0.1s' }}
      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#1a1d28'}
      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
    >
      <td className="px-5 py-4">
        <div className="flex items-center gap-2">
          <ModuleBadge module={query.category} />
          {query.subcategory && (
            <span className="text-xs" style={{ color: '#4b5563' }}>{query.subcategory}</span>
          )}
        </div>
      </td>
      <td className="px-5 py-4">
        <span className="font-mono text-sm font-medium text-gray-200">{query.query_name}</span>
      </td>
      <td className="px-5 py-4">
        {query.is_premium
          ? <PremiumBadge />
          : <span style={{ color: '#374151', fontSize: '13px' }}>—</span>}
      </td>
      <td className="px-5 py-4">
        <div className="flex items-center justify-end gap-1">
          <ActionBtn variant="blue" onClick={onView}>
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            View
          </ActionBtn>
          <ActionBtn variant="red" onClick={onDelete} disabled={deleting}>
            {deleting
              ? <><Spinner className="w-3 h-3" /> Deleting</>
              : <>
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Delete
                </>}
          </ActionBtn>
        </div>
      </td>
    </tr>
  );
}
